import {DatePicker, Form} from "antd";

export function DataToField(){

    return <>
        <Form.Item name={"dataTo"}>
            <DatePicker placeholder="Data a" format="DD/MM/YYYY" />
        </Form.Item>
    </>
}